import { RouteConfig } from 'vue-router';
import { RouterPath } from '../shared/enums';

export default (): Array < RouteConfig > => {
    return [{
            path: RouterPath.ERROR_404,
            name: 'Error 404',
            component: () => import ('./components/pages/page-404').then(m => m.default),
            alias: 'Error 404'
        },
        {
            path: RouterPath.ERROR,
            name: 'Page error',
            component: () => import ('./components/pages/page-error').then(m => m.default),
            alias: 'Page error'
        },
        {
            path: RouterPath.ERROR_WORKSPACE,
            name: 'Page error workspace',
            component: () => import ('./components/pages/page-error-workspace').then(m => m.default),
            alias: 'Page error'
        }
    ];
};
